const en_trans_production = {
    "": "item production process",
    add: "add item production process",
    edit: "edit item production process",
    from_whs: "from warehouse",
    to_whs: "to warehouse",
}

export default en_trans_production;